import apiClient from '../../../api/client';
import type {
  DashboardResponse,
  FacturacionPorDiaResponse,
  PlanVsRealYear,
  RutaCobrosQuery,
  RutaCobrosResponse,
} from '@aid/shared';

export async function getDashboard(): Promise<DashboardResponse> {
  const { data } = await apiClient.get<DashboardResponse>('/admin/dashboard');
  return data;
}

export async function getPlanVsRealYear(year: string): Promise<PlanVsRealYear> {
  const { data } = await apiClient.get<PlanVsRealYear>('/admin/dashboard/plan-vs-real-year', {
    params: { year },
  });
  return data;
}

export async function getFacturacionPorDia(dia: number): Promise<FacturacionPorDiaResponse> {
  const { data } = await apiClient.get<FacturacionPorDiaResponse>(
    '/admin/dashboard/facturacion-por-dia',
    { params: { dia } },
  );
  return data;
}

export async function getRutaCobros(params: RutaCobrosQuery): Promise<RutaCobrosResponse> {
  const { data } = await apiClient.get<RutaCobrosResponse>('/admin/dashboard/ruta-cobros', {
    params,
  });
  return data;
}
